import { render, staticRenderFns } from "./DashboardAllImprovements.vue?vue&type=template&id=a8566f64&scoped=true&lang=pug&"
import script from "./DashboardAllImprovements.vue?vue&type=script&lang=js&"
export * from "./DashboardAllImprovements.vue?vue&type=script&lang=js&"
import style0 from "./DashboardAllImprovements.vue?vue&type=style&index=0&id=a8566f64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8566f64",
  null
  
)

export default component.exports